import { render } from "./profilePage.vue?vue&type=template&id=3be9725d&ts=true"
import script from "./profilePage.vue?vue&type=script&lang=ts"
export * from "./profilePage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__